module.exports = __webpack_public_path__ + "static/media/beatport_green.409f188f.svg";